import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { DepositService } from "../api";

export const actionGetListMethod = createAsyncThunk(
  "deposit/list-method",
  async (_, { rejectWithValue }) => {
    try {
      const res = await DepositService.doGetListMethod();

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetListCurrency = createAsyncThunk(
  "deposit/list-currency",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DepositService.doGetListCurrency(data);

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionInitialOrder = createAsyncThunk(
  "deposit/initial-order",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DepositService.doInitialOrder(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateOrder = createAsyncThunk(
  "deposit/create-order",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DepositService.doCreateOrder(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetListOrder = createAsyncThunk(
  "deposit/list-order",
  async (_, { rejectWithValue }) => {
    try {
      const res = await DepositService.doGetListOrder();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const depositSlice = createSlice({
  name: "deposit",
  initialState: {
    listMethod: {
      loading: false,
      data: null,
      error: "",
    },
    listCurrency: {
      loading: false,
      data: null,
      error: "",
    },
    initialOrder: {
      loading: false,
      data: null,
      error: "",
    },
    createOrder: {
      loading: false,
      data: null,
      error: "",
    },
    listOrder: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // list method
      .addCase(actionGetListMethod.pending, (state) => {
        state.listMethod.loading = true;
      })
      .addCase(actionGetListMethod.fulfilled, (state, action) => {
        state.listMethod.loading = false;
        state.listMethod.data = action.payload;
      })
      .addCase(actionGetListMethod.rejected, (state, action) => {
        state.listMethod.loading = false;
        state.listMethod.data = action.payload;
        state.listMethod.error = action.error.message || "Something went wrong";
      })
      // list Currency
      .addCase(actionGetListCurrency.pending, (state) => {
        state.listCurrency.loading = true;
      })
      .addCase(actionGetListCurrency.fulfilled, (state, action) => {
        state.listCurrency.loading = false;
        state.listCurrency.data = action.payload;
      })
      .addCase(actionGetListCurrency.rejected, (state, action) => {
        state.listCurrency.loading = false;
        state.listCurrency.data = action.payload;
        state.listCurrency.error =
          action.error.message || "Something went wrong";
      })
      // initial Order
      .addCase(actionInitialOrder.pending, (state) => {
        state.initialOrder.loading = true;
      })
      .addCase(actionInitialOrder.fulfilled, (state, action) => {
        state.initialOrder.loading = false;
        state.initialOrder.data = action.payload;
      })
      .addCase(actionInitialOrder.rejected, (state, action) => {
        state.initialOrder.loading = false;
        state.initialOrder.data = action.payload;
        state.initialOrder.error =
          action.error.message || "Something went wrong";
      })

      // create Order
      .addCase(actionCreateOrder.pending, (state) => {
        state.createOrder.loading = true;
      })
      .addCase(actionCreateOrder.fulfilled, (state, action) => {
        state.createOrder.loading = false;
        state.createOrder.data = action.payload;
      })
      .addCase(actionCreateOrder.rejected, (state, action) => {
        state.createOrder.loading = false;
        state.createOrder.data = action.payload;
        state.createOrder.error =
          action.error.message || "Something went wrong";
      })
      // list Order
      .addCase(actionGetListOrder.pending, (state) => {
        state.listOrder.loading = true;
      })
      .addCase(actionGetListOrder.fulfilled, (state, action) => {
        state.listOrder.loading = false;
        state.listOrder.data = action.payload;
      })
      .addCase(actionGetListOrder.rejected, (state, action) => {
        state.listOrder.loading = false;
        state.listOrder.data = action.payload;
        state.listOrder.error = action.error.message || "Something went wrong";
      });
  },
});

export default depositSlice.reducer;
export const { actions, reducer } = depositSlice;
